import React, { useEffect, useRef } from 'react';
import SunriseSunsetApp from './components/SunriseSunsetApp';

function App() {
  const timerRef = useRef(null);

  useEffect(() => {
    const HIDE_DELAY = 3000;

    const showCursor = () => {
      document.body.classList.remove('cursor-hidden');
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        document.body.classList.add('cursor-hidden');
      }, HIDE_DELAY);
    };

    // Start with cursor hidden after initial delay
    timerRef.current = setTimeout(() => {
      document.body.classList.add('cursor-hidden');
    }, HIDE_DELAY);

    window.addEventListener('mousemove', showCursor);
    window.addEventListener('touchstart', showCursor);

    return () => {
      clearTimeout(timerRef.current);
      document.body.classList.remove('cursor-hidden');
      window.removeEventListener('mousemove', showCursor);
      window.removeEventListener('touchstart', showCursor);
    };
  }, []);

  return (
    <div className="App">
      <SunriseSunsetApp />
    </div>
  );
}

export default App;
